namespace Areas {
    "use strict";

    export function showButton(id: string) {
        const button: DevExpress.ui.dxButton = $(`#${id}`).dxButton("instance");

        if (button) {
            button.option("visible", true);
        }
    }

    export function hideButton(id: string) {
        const button: DevExpress.ui.dxButton = $(`#${id}`).dxButton("instance");

        if (button) {
            button.option("visible", false);
        }
    }

    export function enableButton(id: string) {
        const button: DevExpress.ui.dxButton = $(`#${id}`).dxButton("instance");

        if (button) {
            button.option("disabled", false);
        }
    }

    export function disableButton(id: string) {
        const button: DevExpress.ui.dxButton = $(`#${id}`).dxButton("instance");

        if (button) {
            button.option("disabled", true);
        }
    }

}